const EOB_VIEW = 'EOBView';
const LARGE_BATCH_FILES = "LargeBatchFiles";

export {
    EOB_VIEW,
    LARGE_BATCH_FILES
};